export enum ProjectPhase {
  DOING = 'Doing',
  IDEA = 'Ideas',
  DONE = 'Done',
  WONT_DO = "Won't do",
}

export const tabs = [
  ProjectPhase.DOING,
  ProjectPhase.IDEA,
  ProjectPhase.DONE,
  ProjectPhase.WONT_DO,
];

export const FORUM_DESCRIPTION_PLACEHOLDER =
  'Replace this first paragraph with a brief description';
